const state = {
    userPermissions: [],
    permissionsLoaded: false,
};

const mutations = {
    setUserPermissions(state, permissions) {
        state.userPermissions = permissions;
        state.permissionsLoaded = true;
    },
    resetPermissions(state) {
        state.userPermissions = [];
        state.permissionsLoaded = false;
    },
};

const actions = {
    async getUserPermissions({ commit }) {
        try {
            const response = await axios.get(route('user.permissions'));
            commit('setUserPermissions', response.data.permissions);
        } catch (error) {
            console.error('Failed to fetch user permissions:', error);
            commit('setUserPermissions', []);
        }
    },
    
    resetUserPermissions({ commit }) {
        commit('resetPermissions');
    },
};

const getters = {
    hasPermission: (state) => (permissionName) => {
        return state.userPermissions.some(permission => permission.name === permissionName);
    },
    userPermissions: (state) => state.userPermissions,
    permissionsLoaded: (state) => state.permissionsLoaded,
    
    // Helper getter to check multiple permissions at once
    hasAnyPermission: (state) => (permissionNames) => {
        return permissionNames.some(permissionName => 
            state.userPermissions.some(permission => permission.name === permissionName)
        );
    },
    
    // Helper getter to check if user has all permissions
    hasAllPermissions: (state) => (permissionNames) => {
        return permissionNames.every(permissionName => 
            state.userPermissions.some(permission => permission.name === permissionName)
        );
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters,
}; 